import { BookingModel } from "../../models/Bookings";
import { Event } from "../../models/Event";

export interface bookingStateInterface {
  bookings: BookingModel[];
  selectedEvents: Event[];
  lastCursor: string;
  loading: boolean;
}

const initState: bookingStateInterface = {
  bookings: [],
  selectedEvents: [],
  lastCursor: "",
  loading: false,
};

const bookingsReducer: any = (state = initState, action: any) => {
  switch (action.type) {
    case "UPDATE_BOOKING_LIST":
      return {
        ...state,
        bookings: action.payload.bookings,
        lastCursor: action.payload.lastCursor,
      };
    case "UPDATE_SELECTED_EVENT_LIST":
      return {
        ...state,
        selectedEvents: action.payload.selectedEvents,
      };
    case "UPDATE_BOOKING_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
};

export default bookingsReducer;
